import { useMonthFilter } from '@/domain/prices/filters/hooks';
import { usePrices } from '@/domain/prices/prices/hooks';
import { useIntl } from '@/intl';
import { Icon, SpaceBetween, Typography, tk, Button } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

const Wrapper = styled(SpaceBetween)`
  display: flex;
  align-items: center;
  justify-content: end;

  ${Button} {
    ${Button.modSize('small')}
  }

  ${Typography} {
    color: ${tk('color_semantic_text_subdued')};
  }
`;

export const Navigation = () => {
  const intl = useIntl();
  const { isFirstMonth, isLastMonth, goToNextMonth, goToPreviousMonth } = useMonthFilter();
  const { isFetching } = usePrices();

  return (
    <Wrapper direction="x" spacing={tk('spacing_md')}>
      <Button $hierarchy="secondary" $withoutColor onClick={goToPreviousMonth} disabled={isFetching || isFirstMonth}>
        <Icon glyph="IconChevronLeft" />
      </Button>
      <Typography $variant="label-thin">{intl.formatMessage({ id: 'prices_filters_month_navigation' })}</Typography>
      <Button $hierarchy="secondary" $withoutColor onClick={goToNextMonth} disabled={isFetching || isLastMonth}>
        <Icon glyph="IconChevronRight" />
      </Button>
    </Wrapper>
  );
};
